const mistakes = [
  { icon: "ri-time-line", title: "Waiting Too Long to Start", description: "Lakeland residents often underestimate processing times. With Miami 280 miles away and agency appointments scarce statewide, start at least 3 months before travel." },
  { icon: "ri-file-damage-line", title: "Submitting Incomplete Forms", description: "Missing signatures, incorrect dates, or incomplete DS-11/DS-82 forms result in rejection. Our agents review every field before submission." },
  { icon: "ri-camera-off-line", title: "Non-Compliant Passport Photos", description: "Photos taken at pharmacies sometimes don't meet State Department specs. We verify your photos meet all requirements before they go in your application." },
  { icon: "ri-passport-line", title: "Misunderstanding Renewal Eligibility", description: "Not everyone can renew by mail. If your passport is over 15 years old, damaged, or issued before age 16, you must apply in person — we'll tell you which applies." },
  { icon: "ri-calendar-close-line", title: "Misreading Passport Expiration Dates", description: "Many countries require 6 months validity beyond your return date. Polk County travelers often book trips without realizing their passport will be rejected at the border." },
  { icon: "ri-bank-card-line", title: "Forgetting Supporting Documents", description: "Birth certificates, name change documents, and government ID all have specific requirements. Missing one item sends your application back to square one." },
];

export default function MistakesSection() {
  return (
    <section id="mistakes" className="bg-white py-20 md:py-28">
      <div className="max-w-5xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Avoid Delays</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Common Passport Mistakes Made by Lakeland Travelers
          </h2>
          <p className="text-gray-500 max-w-xl mx-auto text-base">
            These mistakes delay thousands of applications every year. Our agents catch them before they become your problem.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-10">
          {mistakes.map((m, i) => (
            <div key={i} className="flex items-start gap-4 bg-[#F7F8FA] rounded-lg p-5 border border-gray-200 hover:border-[#F6C344] transition-all">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-red-50 flex-shrink-0">
                <i className={`${m.icon} text-red-400 text-lg`}></i>
              </div>
              <div>
                <h3 className="font-bold text-[#1A365D] text-sm mb-1">{m.title}</h3>
                <p className="text-gray-500 text-sm leading-relaxed">{m.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-[#1A365D] rounded-lg p-6 flex flex-col sm:flex-row items-center gap-4 text-center sm:text-left">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#F6C344] flex-shrink-0">
            <i className="ri-shield-check-line text-[#1A365D] text-xl"></i>
          </div>
          <div className="flex-1">
            <p className="text-white font-bold text-base">We check everything for you.</p>
            <p className="text-white/70 text-sm mt-1">Fast Passport Center reviews your documents before submission — so you don&apos;t have to worry about these mistakes causing a delay.</p>
          </div>
          <a href="https://fastpassportcenter.com/checkout/" className="bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-6 py-3 rounded-md transition-all whitespace-nowrap flex-shrink-0">
            Get Started
          </a>
        </div>
      </div>
    </section>
  );
}